module.exports = __webpack_public_path__ + "static/ICLEI-2e862a6efbc38c031d6b2666cde3b831.jpg";